var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime-corejs2/core-js/object/define-property", "@babel/runtime-corejs2/core-js/object/define-properties", "@babel/runtime-corejs2/core-js/object/get-own-property-descriptors", "@babel/runtime-corejs2/core-js/object/get-own-property-descriptor", "@babel/runtime-corejs2/core-js/object/get-own-property-symbols", "@babel/runtime-corejs2/core-js/object/keys", "core-js/modules/es6.regexp.to-string", "core-js/modules/es6.date.to-string", "core-js/modules/es6.object.to-string", "@babel/runtime-corejs2/core-js/reflect/construct", "@babel/runtime-corejs2/core-js/number/is-nan", "@babel/runtime-corejs2/helpers/extends", "core-js/modules/es6.string.link", "@babel/runtime-corejs2/helpers/classCallCheck", "@babel/runtime-corejs2/helpers/createClass", "@babel/runtime-corejs2/helpers/assertThisInitialized", "@babel/runtime-corejs2/helpers/inherits", "@babel/runtime-corejs2/helpers/possibleConstructorReturn", "@babel/runtime-corejs2/helpers/getPrototypeOf", "@babel/runtime-corejs2/helpers/defineProperty", "@babel/runtime-corejs2/core-js/parse-int", "core-js/modules/es6.array.find-index", "prop-types", "react", "../../../../breakpoints", "../../Sliders/SingleLineSlider/SingleLineSlider", "../../Teasers/TeaserShow/TeaserShow", "../../UI/Icon/Icon", "../../UI/Icon/Play", "./ProgramPlaylist.css"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime-corejs2/core-js/object/define-property"), require("@babel/runtime-corejs2/core-js/object/define-properties"), require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"), require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"), require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"), require("@babel/runtime-corejs2/core-js/object/keys"), require("core-js/modules/es6.regexp.to-string"), require("core-js/modules/es6.date.to-string"), require("core-js/modules/es6.object.to-string"), require("@babel/runtime-corejs2/core-js/reflect/construct"), require("@babel/runtime-corejs2/core-js/number/is-nan"), require("@babel/runtime-corejs2/helpers/extends"), require("core-js/modules/es6.string.link"), require("@babel/runtime-corejs2/helpers/classCallCheck"), require("@babel/runtime-corejs2/helpers/createClass"), require("@babel/runtime-corejs2/helpers/assertThisInitialized"), require("@babel/runtime-corejs2/helpers/inherits"), require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"), require("@babel/runtime-corejs2/helpers/getPrototypeOf"), require("@babel/runtime-corejs2/helpers/defineProperty"), require("@babel/runtime-corejs2/core-js/parse-int"), require("core-js/modules/es6.array.find-index"), require("prop-types"), require("react"), require("../../../../breakpoints"), require("../../Sliders/SingleLineSlider/SingleLineSlider"), require("../../Teasers/TeaserShow/TeaserShow"), require("../../UI/Icon/Icon"), require("../../UI/Icon/Play"), require("./ProgramPlaylist.css"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.defineProperty, global.defineProperties, global.getOwnPropertyDescriptors, global.getOwnPropertyDescriptor, global.getOwnPropertySymbols, global.keys, global.es6Regexp, global.es6Date, global.es6Object, global.construct, global.isNan, global._extends, global.es6String, global.classCallCheck, global.createClass, global.assertThisInitialized, global.inherits, global.possibleConstructorReturn, global.getPrototypeOf, global.defineProperty, global.parseInt, global.es6Array, global.propTypes, global.react, global.breakpoints, global.SingleLineSlider, global.TeaserShow, global.Icon, global.Play, global.ProgramPlaylist);
    global.ProgramPlaylist = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _defineProperty2, _defineProperties, _getOwnPropertyDescriptors, _getOwnPropertyDescriptor, _getOwnPropertySymbols, _keys, _es6Regexp, _es6Date, _es6Object, _construct, _isNan, _extends2, _es6String, _classCallCheck2, _createClass2, _assertThisInitialized2, _inherits2, _possibleConstructorReturn2, _getPrototypeOf2, _defineProperty3, _parseInt2, _es6Array, _propTypes, _react, _breakpoints, _SingleLineSlider, _TeaserShow, _Icon, _Play, _ProgramPlaylist) {
  "use strict";

  var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty2(_exports, "__esModule", {
    value: true
  });

  _exports.default = _exports.isSmallDevice = void 0;
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _defineProperties = _interopRequireDefault(_defineProperties);
  _getOwnPropertyDescriptors = _interopRequireDefault(_getOwnPropertyDescriptors);
  _getOwnPropertyDescriptor = _interopRequireDefault(_getOwnPropertyDescriptor);
  _getOwnPropertySymbols = _interopRequireDefault(_getOwnPropertySymbols);
  _keys = _interopRequireDefault(_keys);
  _construct = _interopRequireDefault(_construct);
  _isNan = _interopRequireDefault(_isNan);
  _extends2 = _interopRequireDefault(_extends2);
  _classCallCheck2 = _interopRequireDefault(_classCallCheck2);
  _createClass2 = _interopRequireDefault(_createClass2);
  _assertThisInitialized2 = _interopRequireDefault(_assertThisInitialized2);
  _inherits2 = _interopRequireDefault(_inherits2);
  _possibleConstructorReturn2 = _interopRequireDefault(_possibleConstructorReturn2);
  _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf2);
  _defineProperty3 = _interopRequireDefault(_defineProperty3);
  _parseInt2 = _interopRequireDefault(_parseInt2);
  _propTypes = _interopRequireDefault(_propTypes);
  _react = _interopRequireWildcard(_react);
  _SingleLineSlider = _interopRequireDefault(_SingleLineSlider);
  _TeaserShow = _interopRequireDefault(_TeaserShow);
  _Icon = _interopRequireDefault(_Icon);
  _Play = _interopRequireDefault(_Play);

  function ownKeys(object, enumerableOnly) { var keys = (0, _keys.default)(object); if (_getOwnPropertySymbols.default) { var symbols = (0, _getOwnPropertySymbols.default)(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor.default)(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3.default)(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors.default) { (0, _defineProperties.default)(target, (0, _getOwnPropertyDescriptors.default)(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2.default)(target, key, (0, _getOwnPropertyDescriptor.default)(source, key)); }); } } return target; }

  function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

  function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

  var isSmallDevice = function isSmallDevice() {
    return global.innerWidth <= _breakpoints.nextBreakpoints.LARGE;
  };

  _exports.isSmallDevice = isSmallDevice;

  var getSelectedIndex = function getSelectedIndex(teasers, selectedId) {
    return teasers.findIndex(function (_ref) {
      var id = _ref.id;
      return id === selectedId;
    });
  };

  var getComputedHeight = function getComputedHeight(element) {
    return global.getComputedStyle ? (0, _parseInt2.default)(global.getComputedStyle(element).height, 10) : element && element.offsetHeight || 0;
  };

  var ProgramPlaylist = /*#__PURE__*/function (_PureComponent) {
    (0, _inherits2.default)(ProgramPlaylist, _PureComponent);

    var _super = _createSuper(ProgramPlaylist);

    function ProgramPlaylist(props) {
      var _this;

      (0, _classCallCheck2.default)(this, ProgramPlaylist);
      _this = _super.call(this, props);
      (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "onChangedMediaQuery", function () {
        _this.setState({
          smallDevice: isSmallDevice()
        });
      });
      (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "onHeaderKeyPress", function (event) {
        var keyCode = event.nativeEvent.keyCode;

        if (keyCode === 13 || keyCode === 32) {
          event.preventDefault();

          _this.onHeaderClick();
        }
      });
      (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "onHeaderClick", function () {
        _this.setState({
          showList: !_this.state.showList
        });
      });
      (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "handleTeaserClick", function (event, teaser) {
        _this.props.onTeaserClick(event, teaser);
      });
      (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "scrollToCurrentTeaser", function () {
        var teasers = _this.props.teasers;
        var selectedId = _this.state.selectedId;

        if (_this.wrapper) {
          var teaserElements = _this.wrapper.querySelectorAll(_ProgramPlaylist.StyledPlaylistItem);

          var selectedIndex = getSelectedIndex(teasers, selectedId);
          var currentElement = teaserElements[selectedIndex];

          if (currentElement) {
            var scrollY = currentElement.offsetTop - (_this.wrapper.offsetHeight - getComputedHeight(currentElement)) / 2;
            _this.wrapper.scrollTop = Math.max(0, scrollY);
          }
        }
      });
      (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "init", function (wrapper) {
        _this.wrapper = wrapper;
      });
      var selectedTeaserId = props.selectedTeaserId,
          _teasers = props.teasers;
      _this.state = {
        selectedId: selectedTeaserId || _teasers.length && _teasers[0] && _teasers[0].id || null,
        showList: true,
        smallDevice: false
      };
      _this.wrapper = null;
      return _this;
    }

    (0, _createClass2.default)(ProgramPlaylist, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        // ! because of SSR we have to test smallDevice client-side
        // ! once smallDevice state is updated and re-render is done.
        // eslint-disable-next-line react/no-did-mount-set-state
        this.setState({
          smallDevice: isSmallDevice()
        });
        this.mediaQueryListM = global.matchMedia('(max-width: 1023px)');
        this.mediaQueryListXL = global.matchMedia('(min-width: 1024px)');
        this.mediaQueryListM.addListener(this.onChangedMediaQuery);
        this.mediaQueryListXL.addListener(this.onChangedMediaQuery);
        this.scrollToCurrentTeaser();
      }
    }, {
      key: "UNSAFE_componentWillReceiveProps",
      value: function UNSAFE_componentWillReceiveProps(props) {
        var selectedTeaserId = props.selectedTeaserId;
        this.setState({
          selectedId: selectedTeaserId || null,
          showList: true
        });
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps, prevState) {
        if (prevState.selectedId !== this.state.selectedId) {
          this.scrollToCurrentTeaser();
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.mediaQueryListM.removeListener(this.onChangedMediaQuery);
        this.mediaQueryListXL.removeListener(this.onChangedMediaQuery);
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        var _this$props = this.props,
            autoplayLabel = _this$props.autoplayLabel,
            headerRenderLink = _this$props.headerRenderLink,
            isAutoplayActivated = _this$props.isAutoplayActivated,
            labels = _this$props.labels,
            link = _this$props.link,
            onAutoplayChange = _this$props.onAutoplayChange,
            subtitle = _this$props.subtitle,
            teasers = _this$props.teasers,
            title = _this$props.title,
            titleLevel = _this$props.titleLevel;
        var _this$state = this.state,
            selectedId = _this$state.selectedId,
            showList = _this$state.showList,
            smallDevice = _this$state.smallDevice;
        var ariaProps = {
          'aria-label': labels.showSuggestedVideo
        };

        if (smallDevice) {
          ariaProps['aria-expanded'] = showList ? 'true' : 'false';
        }

        var selectedIndex = getSelectedIndex(teasers, selectedId);
        var ComputedStyledPlaylistHeader = smallDevice ? _ProgramPlaylist.StyledPlaylistHeaderMobile : _ProgramPlaylist.StyledPlaylistHeaderDesktop;

        var ComputedStyledPlayListTitle = _ProgramPlaylist.StyledPlaylistTitle.withComponent("h".concat(titleLevel), {
          target: "e19iugdr0",
          label: "ComputedStyledPlayListTitle"
        });

        var ComputedStyledPlayListSubtitle = _ProgramPlaylist.StyledPlaylistSubtitle.withComponent("h".concat(titleLevel), {
          target: "e19iugdr1",
          label: "ComputedStyledPlayListSubtitle"
        });

        var HeaderTitleWrapper = link.length && !smallDevice ? _ProgramPlaylist.StyledPlaylistTitleLink : function (_ref2) {
          var children = _ref2.children;
          return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children);
        };
        return /*#__PURE__*/_react.default.createElement(_ProgramPlaylist.StyledPlaylist, {
          open: showList,
          counterVisible: selectedIndex >= 0
        }, /*#__PURE__*/_react.default.createElement(_ProgramPlaylist.PlaylistHeaderContainer, null, /*#__PURE__*/_react.default.createElement(_ProgramPlaylist.SwitchWithLabel, {
          isChecked: isAutoplayActivated,
          label: autoplayLabel,
          onChange: onAutoplayChange,
          id: "autoplay"
        }), /*#__PURE__*/_react.default.createElement(ComputedStyledPlaylistHeader, (0, _extends2.default)({}, smallDevice ? ariaProps : {}, {
          onClick: this.onHeaderClick,
          onKeyDown: this.onHeaderKeyPress
        }), /*#__PURE__*/_react.default.createElement(HeaderTitleWrapper, (0, _extends2.default)({
          href: link,
          renderLink: headerRenderLink
        }, ariaProps), /*#__PURE__*/_react.default.createElement(_ProgramPlaylist.HeaderTitleContainer, null, /*#__PURE__*/_react.default.createElement(ComputedStyledPlayListTitle, {
          textEllipsis: smallDevice
        }, title), subtitle && /*#__PURE__*/_react.default.createElement(ComputedStyledPlayListSubtitle, {
          visible: showList
        }, subtitle))), /*#__PURE__*/_react.default.createElement(_ProgramPlaylist.StyledPlaylistToggle, null, selectedIndex >= 0 && /*#__PURE__*/_react.default.createElement(_ProgramPlaylist.StyledPlaylistCounter, null, selectedIndex + 1, "/", teasers.length), /*#__PURE__*/_react.default.createElement(_Icon.default, {
          name: showList ? 'arte-icon--up2' : 'arte-icon--down2',
          size: "xsmall",
          color: "white"
        }))), /*#__PURE__*/_react.default.createElement(_ProgramPlaylist.PlaylistHeaderSeparator, null)), /*#__PURE__*/_react.default.createElement(_ProgramPlaylist.StyledPlaylistWrapper, {
          visible: showList,
          ref: this.init
        }, smallDevice ? /*#__PURE__*/_react.default.createElement(_SingleLineSlider.default, {
          activeIndex: selectedIndex,
          kind: "PROGRAM_PLAYLIST",
          teasers: teasers,
          onTeaserClick: function onTeaserClick(event, index) {
            _this2.handleTeaserClick(event, teasers[index]);
          }
        }) : teasers.map(function (teaser, index) {
          var active = teaser.id === selectedId;
          var id = teaser.id,
              images = teaser.images,
              teaserSubtitle = teaser.subtitle,
              teaserTitle = teaser.title,
              url = teaser.url,
              renderLink = teaser.renderLink;
          var duration = Math.round(teaser.duration);
          var teaserInfo = {
            id: id,
            images: images
          };

          var teaserImage = /*#__PURE__*/_react.default.createElement(_TeaserShow.default, _objectSpread({
            className: 'teaser-image',
            tabIndex: -1
          }, teaserInfo));

          var linkProps = {
            key: "playlist-item-".concat(teaserInfo.id),
            onClick: function onClick(event) {
              return _this2.handleTeaserClick(event, teaser);
            },
            href: url
          };
          return /*#__PURE__*/_react.default.createElement(_ProgramPlaylist.StyledPlaylistItem, (0, _extends2.default)({}, linkProps, {
            selected: active,
            renderLink: renderLink
          }), /*#__PURE__*/_react.default.createElement(_ProgramPlaylist.StyledPlaylistItemNumber, null, active ? /*#__PURE__*/_react.default.createElement(_Play.default, {
            size: "xxsmall"
          }) : index + 1), teaserImage, /*#__PURE__*/_react.default.createElement(_ProgramPlaylist.StyledPlaylistItemTitleWrapper, null, /*#__PURE__*/_react.default.createElement(_ProgramPlaylist.StyledPlaylistItemTitle, null, teaserTitle), teaserSubtitle && /*#__PURE__*/_react.default.createElement(_ProgramPlaylist.StyledPlaylistItemSubtitle, null, teaserSubtitle), !(0, _isNan.default)(duration) && duration > 0 && /*#__PURE__*/_react.default.createElement(_ProgramPlaylist.StyledPlaylistItemDuration, null, duration, " ", labels.durationUnit)));
        })));
      }
    }]);
    return ProgramPlaylist;
  }(_react.PureComponent);

  ProgramPlaylist.propTypes = {
    autoplayLabel: _propTypes.default.string,
    headerRenderLink: _propTypes.default.func,
    isAutoplayActivated: _propTypes.default.bool,
    labels: _propTypes.default.shape({
      showSuggestedVideo: _propTypes.default.string,
      durationUnit: _propTypes.default.string
    }),
    link: _propTypes.default.string,
    onAutoplayChange: _propTypes.default.func,
    onTeaserClick: _propTypes.default.func,
    selectedTeaserId: _propTypes.default.string,
    subtitle: _propTypes.default.string.isRequired,
    teasers: _propTypes.default.arrayOf(_propTypes.default.shape()).isRequired,
    title: _propTypes.default.string.isRequired,
    titleLevel: _propTypes.default.oneOf([1, 2, 3, 4, 5, 6])
  };
  ProgramPlaylist.defaultProps = {
    autoplayLabel: '',
    isAutoplayActivated: true,
    labels: {
      durationUnit: 'min',
      showSuggestedVideo: 'show suggested videos'
    },
    link: '',
    // eslint-disable-next-line no-unused-vars
    onAutoplayChange: function onAutoplayChange(isActivated) {},
    // eslint-disable-next-line no-unused-vars
    onTeaserClick: function onTeaserClick(event, teaser) {},
    subtitle: '',
    teasers: [],
    title: '',
    titleLevel: 2
  };
  var _default = ProgramPlaylist;
  _exports.default = _default;
});